import {
  Button,
  Checkbox,
  Classes,
  Dialog,
  FormGroup
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { TipiStore } from "../../stores/legislacao/TipiStore";
import { MDBCol, MDBRow } from "mdbreact";
import { ITipi } from "../../model";

interface TipiDialogEditProps {
  tipi: ITipi;
  onClose: () => void;
}

interface TipiDialogEditState {
}

@observer
export class TipiDialogEdit
  extends React.Component<TipiDialogEditProps, TipiDialogEditState> {
  obs = observable({
    tipi: {} as ITipi,
    segmentos_selecionados: [] as any
  })

  async componentDidMount() {
    this.obs.tipi = this.props.tipi;
  }

  /**
  * Edita um registro de TIPI com base nos dados fornecidos.
  *
  * A função:
  * - Extrai os campos necessários do objeto `tipi` para formar os `params`:
  *   - `id`: usa `tipi._id` ou `tipi.id`.
  *   - `seg_auto_pecas`: assume `false` caso não seja informado.
  *   - `seg_vet_pet`: assume `false` caso não seja informado.
  * - Envia os dados para o método `TipiStore.handleSaveEdit(params)` via **POST/PUT** (dependendo da implementação interna).
  * - Se a resposta (`res`) for positiva:
  *   - Executa `this.props.onClose()` para fechar a interface/modal.
  *
  * @async
  * @param {Object} tipi Objeto TIPI contendo os dados a serem atualizados.
  * @param {string} [tipi._id] ou [tipi.id] Identificador do registro TIPI.
  * @param {boolean} [tipi.seg_auto_pecas=false] Indica se pertence ao segmento de autopeças.
  * @param {boolean} [tipi.seg_vet_pet=false] Indica se pertence ao segmento veterinário/pet.
  *
  * @returns {Promise<void>} Promise resolvida após tentativa de edição.
  */

  handleEditTipi = async (tipi) => {
  
    const params = {
      id: tipi._id || tipi.id,
      seg_auto_pecas: tipi.seg_auto_pecas || false,
      seg_vet_pet: tipi.seg_vet_pet || false,
      seg_refrigerantes : tipi.seg_refrigerantes || false,
      seg_agua_out : tipi.seg_agua_out || false,
      seg_lamp_reatores : tipi.seg_lamp_reatores || false,
      seg_mat_limpeza : tipi.seg_mat_limpeza || false,
      seg_pneumaticos_prot : tipi.seg_pneumaticos_prot || false,
      seg_alimenticios : tipi.seg_alimenticios || false,
      seg_perf_cosm : tipi.seg_perf_cosm || false,
      seg_eletro : tipi.seg_eletro || false,
      seg_racoes : tipi.seg_racoes || false,
      seg_sorvetes_fab : tipi.seg_sorvetes_fab || false,
      seg_tintas : tipi.seg_tintas || false,
      seg_mat_construcao : tipi.seg_mat_construcao || false,
      seg_veiculos_automotores : tipi.seg_veiculos_automotores || false,
      seg_veiculos_novos : tipi.seg_veiculos_novos || false,
      seg_medicamentos_humano : tipi.seg_medicamentos_humano || false
    }

    let res = await TipiStore.handleSaveEdit(params);

    if (res) {

      this.props.onClose()

    }

  };

  render() {

    if (!this.obs.tipi) {
      return null;
    }

    return (
      <Dialog
        isOpen={true}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_HEADER}>
          <h2 className="title-no-bottom">Editar Tipi</h2>
        </div>

        <div className={Classes.DIALOG_BODY}>
          <MDBRow>
            <MDBCol>
              <div className={Classes.DIALOG_BODY}>
                <FormGroup
                  label="Selecione os segmentos:"
                  labelFor="segmentos"
                  >
                  <div style ={{overflow: "auto", maxHeight: 400}}>
                    <Checkbox
                      label={"Autopeças"}
                      checked={this.obs.tipi.seg_auto_pecas}
                      onChange={(event: any) => this.obs.tipi.seg_auto_pecas = event.target.checked}
                    />
                    <Checkbox
                      label={"Veterinário/pet"}
                      checked={this.obs.tipi.seg_vet_pet}
                      onChange={(event: any) => this.obs.tipi.seg_vet_pet = event.target.checked}
                    />
                    <Checkbox
                      label={"Refrigerantes"}
                      checked={this.obs.tipi.seg_refrigerantes}
                      onChange={(event: any) => this.obs.tipi.seg_refrigerantes = event.target.checked}
                    />
                    <Checkbox
                      label={"Aguas e outras bebidas"}
                      checked={this.obs.tipi.seg_agua_out}
                      onChange={(event: any) => this.obs.tipi.seg_agua_out = event.target.checked}
                    />
                    <Checkbox
                      label={"Lâmpadas, reatores e starter"}
                      checked={this.obs.tipi.seg_lamp_reatores}
                      onChange={(event: any) => this.obs.tipi.seg_lamp_reatores = event.target.checked}
                    />
                    <Checkbox
                      label={"Materiais de limpeza"}
                      checked={this.obs.tipi.seg_mat_limpeza}
                      onChange={(event: any) => this.obs.tipi.seg_mat_limpeza = event.target.checked}
                    />
                    <Checkbox
                      label={"Pneumáticos, câmaras de ar e protetores de borracha"}
                      checked={this.obs.tipi.seg_pneumaticos_prot}
                      onChange={(event: any) => this.obs.tipi.seg_pneumaticos_prot = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos alimentícios"}
                      checked={this.obs.tipi.seg_alimenticios}
                      onChange={(event: any) => this.obs.tipi.seg_alimenticios = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos de perfumaria e de higiene pessoal e cosméticos"}
                      checked={this.obs.tipi.seg_perf_cosm}
                      onChange={(event: any) => this.obs.tipi.seg_perf_cosm = event.target.checked}
                    />
                    <Checkbox
                      label={"Produtos eletrônicos, eletroeletrônicos e eletrodomésticos"}
                      checked={this.obs.tipi.seg_eletro}
                      onChange={(event: any) => this.obs.tipi.seg_eletro = event.target.checked}
                    />
                    <Checkbox
                      label={"Rações para animais domésticos"}
                      checked={this.obs.tipi.seg_racoes}
                      onChange={(event: any) => this.obs.tipi.seg_racoes = event.target.checked}
                    />
                    <Checkbox
                      label={"Sorvetes e preparados para fabricação de sorvetes em máquinas"}
                      checked={this.obs.tipi.seg_sorvetes_fab}
                      onChange={(event: any) => this.obs.tipi.seg_sorvetes_fab = event.target.checked}
                    />
                    <Checkbox
                      label={"Tintas e vernizes"}
                      checked={this.obs.tipi.seg_tintas}
                      onChange={(event: any) => this.obs.tipi.seg_tintas = event.target.checked}
                    />
                    <Checkbox
                      label={"Material de construção"}
                      checked={this.obs.tipi.seg_mat_construcao}
                      onChange={(event: any) => this.obs.tipi.seg_mat_construcao = event.target.checked}
                    />
                    <Checkbox
                      label={"Veículos automotores novos"}
                      checked={this.obs.tipi.seg_veiculos_automotores}
                      onChange={(event: any) => this.obs.tipi.seg_veiculos_automotores = event.target.checked}
                    />
                    <Checkbox
                      label={"Veículos novos de duas e três rodas motorizados"}
                      checked={this.obs.tipi.seg_veiculos_novos}
                      onChange={(event: any) => this.obs.tipi.seg_veiculos_novos = event.target.checked}
                    />
                    <Checkbox
                      label={"Medicamentos de uso humano e outros produtos farmacêuticos"}
                      checked={this.obs.tipi.seg_medicamentos_humano}
                      onChange={(event: any) => this.obs.tipi.seg_medicamentos_humano = event.target.checked}
                    />
                  </div>
                </FormGroup>
              </div>
            </MDBCol>
          </MDBRow>

        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleEditTipi(this.obs.tipi)} />
          </div>
        </div>
      </Dialog>
    );
  }
}
